module.exports = __webpack_public_path__ + "img/recipe.00d791c0.png";